module.exports = __webpack_public_path__ + "static/arrow.64c74fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.png
// module id = 576
// module chunks = 76758144387212